<div class="w-100 dropdown-container" [class.disabled]="isDisabled">
  <div class="position-relative w-100">
    <div class="d-flex justify-content-between dropdown-input input" (click)="toggleDropdown()">
      <p class="mb-0" *ngIf="selectedHotels?.length === 0">-- select hotels --</p>
      
      <div class="d-flex selected-items-container">
        <ng-container *ngFor="let selected of selectedHotels">
          <ng-container *ngFor="let location of selected.locations">
            <ng-container *ngFor="let hotel of location.hotels">
              <div class="item">
                {{ hotel.hotelName }}
                <button
                  class="close-btn"
                  (click)="removeHotel(selected.destination, location.locationName); $event.stopPropagation()"
                  [disabled]="isDisabled">
                  x
                </button>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>

      <div class="">
        <ion-button class="dropdown-btn" fill="clear">
          <ion-icon name="chevron-down-outline"></ion-icon>
        </ion-button>
      </div>
    </div>

    <div class="dropdown-list-main" *ngIf="dropdownVisible">
      <div class="dropdown-list">
        <div *ngFor="let destination of formattedHotels">
          <p class="destination-name">{{ destination.destination }}</p>

          <div *ngFor="let location of destination.locations">
            <p class="hotel-location">{{ location.locationName }}</p>

            <div class="px-2 mb-2">
              <table class="hotel-table">
                <tr *ngFor="let hotel of location.hotels"
                    (click)="selectHotel(destination.destination, location.locationName, hotel)"
                    [class.disabled]="isDisabled">
                  <td class="cell-w-sm align-vertical">
                    <input type="radio"
                           [checked]="isChecked(destination.destination, location.locationName, hotel)"
                           [disabled]="isDisabled"/>
                  </td>
                  <td class="hotel-name">{{ hotel?.hotelName }}</td>
                  <td class="cell-w-md">{{ hotel?.hotelType || "--" }}</td>
                  <td class="cell-w-md">{{ hotel?.roomCategory || "--" }}</td>
                  <td class="cell-w-md">{{ hotel?.totalRooms }} Rooms</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
